import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);

const backupService = {
  /**
   * Create a new backup
   */
  createBackup: async (includes = { database: true, files: true, config: true }) => {
    try {
      const response = await apiClient.post(
        '/backups',
        { includes }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get all backups
   */
  getAllBackups: async () => {
    try {
      const response = await apiClient.get('/backups');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Download a backup
   */
  downloadBackup: async (backupId) => {
    try {
      const response = await apiClient.get(
        `/backups/${backupId}/download`,
        { responseType: 'blob' }
      );
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let fileName = `backup-${Date.now()}.zip`;
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Delete a backup
   */
  deleteBackup: async (backupId) => {
    try {
      const response = await apiClient.delete(`/backups/${backupId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get backup settings
   */
  getSettings: async () => {
    try {
      const response = await apiClient.get('/backups/settings');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Update backup settings
   */
  updateSettings: async (settings) => {
    try {
      const response = await apiClient.put(
        '/backups/settings',
        settings
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get backup statistics
   */
  getStatistics: async () => {
    try {
      const response = await apiClient.get('/backups/statistics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Clean old backups
   */
  cleanOldBackups: async () => {
    try {
      const response = await apiClient.post('/backups/clean', {});
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default backupService;

